import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { TextArea as ValueLinkTextArea } from 'local_modules/valuelink'
import Media from 'local_modules/Media'

import s from './TextArea.scss'


class TextArea extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    placeholder: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    type: PropTypes.string,
    valueLink: PropTypes.object.isRequired,
    focusOnInit: PropTypes.bool,
    multiline: PropTypes.bool,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    required: PropTypes.bool,
  }

  static defaultProps = {
    focusOnInit: false,
    multiline: false,
    disabled: false,
    readOnly: false,
    required: false,
    type: 'text',
  }

  state = {
    error: null,
    valid: null,
  }

  setNode = (el) => {
    this.node = el
  }

  onKeyUp = () => {
    const textArea = this.node.children[0]

    textArea.style.height = '0'
    textArea.style.height = `${textArea.scrollHeight}px`
    textArea.style.maxHeight = `${textArea.scrollHeight}px`
  }

  render() {
    const { error: isError } = this.state
    const { valueLink, placeholder, placeholderClassName, label, mobile, className } = this.props

    const error   = valueLink.error || isError
    const empty   = !Boolean(valueLink.value)

    const textAreaWrapperStyleName = cx(s.textAreaWrapper, {
      [s.error]: Boolean(error),
      // [s.checked]: checked,
    })

    const textAreaClassName = cx({
      [s.notEmpty]: !empty,
    })

    return (
      <label
        ref={this.setNode}
        className={cx(textAreaWrapperStyleName, className)}
      >
        <ValueLinkTextArea
          className={textAreaClassName}
          valueLink={valueLink}
          onBlur={this.onBlur}
          onKeyUp={this.onKeyUp}
          onKeyPress={this.onKeyUp}
        />
        {
          Boolean(error || placeholder) && (
            <p className={cx(s.placeholder, placeholderClassName, { [s.error]: Boolean(error) })}>
              {error || placeholder}
            </p>
          )
        }
      </label>
    )
  }
}


export default TextArea
